export default __webpack_public_path__ + "static/media/slide1.bcb17da5.png";